import React, { useEffect, useState } from "react";
import SidebarItem from "../components/SidebarItem";
import "../css/SidebarItem.css";
import DashboardIcon from "../assets/icons/dashboardsvg.png";
import UserIcon from "../assets/icons/users.png";
import ModelIcon from "../assets/icons/modelsvg.png";
import ProductIcon from "../assets/icons/productsvg.png";
import SubscrptionIcon from "../assets/icons/paymentsvg.png";
import EnterpriseIcon from "../assets/icons/enterprisesvg.png";
import ModuleIcon from "../assets/icons/modulesvg.png";
import botIcon from "../assets/icons/botIcon.png";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedMenu, setRefreshSidebar } from "../redux/sidebarSlice";
import api from "../api";
import { useNavigate } from "react-router-dom";
import VelaKoda from "../assets/Images/LoginLogo.svg";
import VelaLogo from "../assets/Images/ZeroBoxLogo.svg";
import { showErrorToast } from "../utils/toastUtils";
import { TOAST_MESSAGES } from "../utils/toastMessages";

const SuperAdminSidebar = ({ expanded, toggleSidebar }) => {
  const dispatch = useDispatch();
  const [dynamicModules, setDynamicModules] = useState([]);
  const refreshSidebar = useSelector((state) => state.sidebar.refreshSidebar);
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);
  const navigate = useNavigate();
  const [versions, setVersions] = useState([]);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const handleMenuClick = (label) => {
    dispatch(setSelectedMenu(label));
  };

  const fetchModules = async () => {
    try {
      const res = await api.get(`${process.env.REACT_APP_API_URL}/modules`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDynamicModules(res.data);
    } catch (err) {
      console.error("Failed to fetch modules for sidebar", err);
    }
  };

  useEffect(() => {
    fetchModules();
    if (refreshSidebar) {
      dispatch(setRefreshSidebar(false));
    }
  }, [refreshSidebar]);

  const handleLogoClick = () => {
    navigate("/"); // navigate to login page
  };

  const fetchVersions = async () => {
    if (!token) {
      showErrorToast(TOAST_MESSAGES.UNAUTHORIZED);
      return;
    }
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/version-history`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setVersions(response.data);
    } catch (error) {
      console.error("Failed to fetch versions", error);
      //   showErrorToast(TOAST_MESSAGES.VERSION.FETCH_ERROR);
    }
  };

  useEffect(() => {
    fetchVersions();
  }, []);

  return (
    <div
      className={`sidebar d-flex flex-column justify-content-between ${
        expanded ? "expanded" : "collapsed"
      }`}
      style={{ height: "100vh" }}
    >
      <div>
        {/* <div
          className={`logo-section ${
            expanded
              ? "d-flex justify-content-between align-items-center px-3"
              : "d-flex align-items-center justify-content-center gap-2 py-2"
          }`}
        >
          {expanded ? (
            <>
              <img
                src="/asset/logo.png"
                alt="Logo"
                className="logo"
                style={{
                  width: "160px",
                  height: "30px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                onClick={handleLogoClick}
              />
              <button onClick={toggleSidebar} className="sidebar-toggler ms-2">
                <i className="bi bi-chevron-double-left" />
              </button>
            </>
          ) : (
            <>
              <img
                src={botIcon}
                alt="Bot Icon"
                className={`bot-icon ${expanded ? "expanded" : "collapsed"}`}
                style={{ cursoer: "pointer" }}
                onClick={handleLogoClick}
              />
              <button
                onClick={toggleSidebar}
                className={`sidebar-toggler ${
                  expanded ? "expanded" : "collapsed"
                }`}
              >
                <i className="bi bi-chevron-double-right" />
              </button>
            </>
          )}
        </div> */}
        <div
          className={`logo-section ${
            expanded
              ? "d-flex justify-content-between align-items-center px-3"
              : "d-flex align-items-center justify-content-center gap-2 py-2"
          }`}
        >
          {expanded ? (
            <>
              <img
                src={VelaKoda}
                alt="Logo"
                className="logo"
                style={{
                  width: "160px",
                  height: "30px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                onClick={handleLogoClick}
              />
              <button onClick={toggleSidebar} className="sidebar-toggler ms-2">
                <i className="bi bi-chevron-double-left" />
              </button>
            </>
          ) : (
            <>
              <img
                src={VelaLogo}
                alt="Bot Icon"
                className={`bot-icon w-50 ${
                  expanded ? "expanded" : "collapsed"
                }`}
                style={{ cursoer: "pointer" }}
                onClick={handleLogoClick}
              />
              <button
                onClick={toggleSidebar}
                className={`sidebar-toggler ${
                  expanded ? "expanded" : "collapsed"
                }`}
              >
                <i className="bi bi-chevron-double-right" />
              </button>
            </>
          )}
        </div>

        <ul className="menu">
          {/* Dynamically Added Modules */}
          {[...dynamicModules]
            .filter((mod) => mod.module_status === "1")
            .sort((a, b) => {
              const orderA = Number.isFinite(Number(a.module_order))
                ? Number(a.module_order)
                : Number.MAX_SAFE_INTEGER;
              const orderB = Number.isFinite(Number(b.module_order))
                ? Number(b.module_order)
                : Number.MAX_SAFE_INTEGER;

              if (orderA !== orderB) return orderA - orderB;
              return (a.module_name || "").localeCompare(b.module_name || "");
            })
            .map((mod) => (
              <SidebarItem
                key={mod.module_id}
                icon={
                  mod.module_icon
                    ? `${process.env.REACT_APP_SERVER_URL}/${mod.module_icon}`
                    : ModuleIcon
                }
                label={mod.module_name}
                to={`/superadmin/${mod.module_name
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
                expanded={expanded}
                onClick={() => handleMenuClick(mod.module_name)}
                active={selectedMenu === mod.module_name}
              />
            ))}

          <SidebarItem
            icon={ModuleIcon}
            label="Module Management"
            to="/superadmin/module"
            expanded={expanded}
            onClick={() => handleMenuClick("Module Management")}
            active={selectedMenu === "Module Management"}
          />
        </ul>
      </div>

      {/* <div
        className="text-center"
        style={{ color: "white", cursor: "pointer" }}
      >
        <p
          style={{ fontSize: "small" }}
          onClick={() => {
            navigate("/superadmin/version-management");
            dispatch(setSelectedMenu("Version Management"));
          }}
        >
          v1.1.9
        
        </p>
      </div> */}
      <div className="text-center c tooltip1" style={{ color: "white" }}>
        {versions.length > 0 && (
          <>
            <p
              style={{ fontSize: "small" }}
              onClick={() => {
                navigate("/superadmin/version-management");
                dispatch(setSelectedMenu("Version Management"));
              }}
            >
              {versions[0].version_number}
            </p>

            <span className="tooltip1text">
              <table className="tooltip-table">
                <thead>
                  <tr>
                    <th>Version</th>
                    <th>Release Date</th>
                    <th>Changes</th>
                  </tr>
                </thead>
                <tbody>
                  {versions.map((v) => (
                    <tr key={v.id}>
                      <td>{v.version_number}</td>
                      <td>
                        {v.version_release_date
                          ? new Date(
                              v.version_release_date
                            ).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>{v.version_changes || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default SuperAdminSidebar;
